import { usePDF } from 'react-to-pdf';
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { formatPricePersian, getFarsiNumber } from '../../utils/number';
import dayjs from 'dayjs';

export default function InvoiceItem() {
	const { toPDF, targetRef } = usePDF({ filename: 'page.pdf' });
	const { id } = useParams();

	const { t } = useTranslation();
	const headers = ['row', 'product_id', 'description_or_introdus_product', 'count', 'unit', 'one_amount', 'total_amount', 'tax', 'final_price'];

	const [data, setData] = useState<any>(null);
	const [company, setCompany] = useState<any>(null);
	const todayShamsi = dayjs()?.locale('fa')?.format('YYYY/MM/DD');
	useEffect(() => {
		axios({
			url: `/accounting-profile/invoices/${id}`,
			method: 'GET',
		}).then(r => {
			if (r?.data?.success) {
				setData(r?.data?.data);
			}
		});
		axios({
			url: `/blocks/contact_us`,
			method: 'GET',
		}).then(r => {
			if (r?.data?.success) {
				setCompany(r?.data?.data['contact_us']);
			}
		});
	}, []);
	return (
		<Box className="w-full">
			<Button variant={'contained'} onClick={() => toPDF()} className={'flex flex-col justify-end'}>
				{t('export_pdf')}
			</Button>
			<Box className="relative my-8 w-full border border-black bg-white p-2.5" ref={targetRef}>
				<Typography className="my-7 text-center text-xl font-bold">{t('invoice_for_the_sale_of_goods_and_services')}</Typography>
				<Typography className="absolute left-6 top-0 my-7 text-center text-xs font-medium">
					{t('date')} : {todayShamsi}
				</Typography>
				<Box className="mb-2.5 flex gap-x-4 border border-black p-4">
					<Typography className="m-2">
						<span className="mx-0.5 font-medium">{t('company_name_or_seller')}</span> :{' '}
					</Typography>
					<Typography className="m-2">
						<span className="mx-0.5 font-medium">{t('economic_number')}</span> : {getFarsiNumber('09219279910001')}{' '}
					</Typography>
					<Typography className="m-2">
						<span className="mx-0.5 font-medium">{t('id_nationalcode')}</span> : {getFarsiNumber('0921927991')}
					</Typography>
					<Typography className="m-2">
						<span className="mx-0.5 font-medium">{t('registration_number')}</span> :{' '}
					</Typography>
					<Typography className="m-2">
						<span className="mx-0.5 font-medium">{t('address')}</span> : {company && company[1]?.data[0]?.description}
					</Typography>
					<Typography className="m-2">
						<span className="mx-0.5 font-medium">{t('postal_code')}</span> : {getFarsiNumber('9189664970')}
					</Typography>
				</Box>
				<Box className="flex gap-x-4 border border-black p-4">
					<Typography className="m-2">
						<span className="mx-0.5 font-medium">{t('company_name_or_buyer')}</span> : {data && data.source.title}
					</Typography>
					<Typography className="m-2">
						<span className="mx-0.5 font-medium">{t('economic_number')}</span> : ____{' '}
					</Typography>
					<Typography className="m-2">
						<span className="mx-0.5 font-medium">{t('id_nationalcode')}</span> :
					</Typography>
					<Typography className="m-2">
						<span className="mx-0.5 font-medium">{t('phone_number')}</span> : {data && data.source.phone}
					</Typography>
					<Typography className="m-2">
						<span className="mx-0.5 font-medium">{t('address')}</span> :{' '}
					</Typography>
					<Typography className="m-2">
						<span className="mx-0.5 font-medium">{t('postal_code')}</span> :{' '}
					</Typography>
				</Box>
				<table className="mt-5 w-full table-fixed border border-black">
					<thead>
						<tr>
							{headers.map((header, index) => (
								<th key={index} className="border border-black py-5">
									{t(header)}
								</th>
							))}
						</tr>
					</thead>
					<tbody className="[&>*:nth-child(even)]:bg-white [&>*:nth-child(odd)]:bg-gray-200">
						<tr className="nth-child-3">
							{data &&
								data.items &&
								data?.items.map((item: any, index: number) => (
									<>
										<td className="border border-black p-5">{index}</td>
										<td className="border border-black p-5">{formatPricePersian(item.id)}</td>
										<td className="border border-black p-5">_</td>
										<td className="border border-black p-5">{formatPricePersian(item.count)}</td>
										<td className="border border-black p-5">{item.unit}</td>
										<td className="border border-black p-5">{formatPricePersian(item.price)}</td>
										<td className="border border-black p-5">{formatPricePersian(item.total_price)}</td>
										<td className="border border-black p-5">{formatPricePersian(item.tax)}</td>
										<td className="border border-black p-5">{formatPricePersian(item.final_price)}</td>
									</>
								))}
						</tr>
						<tr>
							<td className="border border-black p-5" colSpan={5}>
								______________
							</td>
							{data && (
								<>
									<td className="border border-black p-5">___</td>
									<td className="border border-black p-5">___</td>
									<td className="border border-black p-5">___</td>
									<td className="border border-black p-5">{formatPricePersian(data.total_price)}</td>
								</>
							)}
						</tr>
					</tbody>
				</table>
			</Box>
		</Box>
	);
}
